import {Button} from 'antd';
import React from 'react';

interface RemovableCardProps {
  title: React.ReactNode;
  children: React.ReactNode;
  onRemove?: () => void;
  showRemove?: boolean;
  variant?: string;
}

const RemovableCard: React.FC<RemovableCardProps> = ({
  title,
  children,
  onRemove,
  showRemove = true,
  variant = 'default'
}) => {
  return (
    <div className={`removable-card removable-card-${variant}`}>
      <div className="removable-card-header">
        <h4 className="removable-card-title">{title}</h4>
        {showRemove && onRemove && (
          <Button className="removable-card-remove" onClick={onRemove}>
            Remove
          </Button>
        )}
      </div>
      <div className="removable-card-body">{children}</div>
    </div>
  );
};
export default RemovableCard;
